import { _ } from "../../../polyglot/polyglot.js";
import { makeDropdown } from "../../makeRoadmapStepContent.js";
import AbstractRoadmapStep from "../../AbstractRoadmapStep.js";

/**
 * This allows the user to choose the type of Bank account.
 */
export default class BankAccountStep extends AbstractRoadmapStep {
	getTitle() {
		return _("Bank account");
	}

	_getSubtitle() {
		return _(
			"As you forecast income and costs this will affect the bank account balance. Which bank account do you want to be affected?",
		);
	}

	_doSubmit({ onDone }) {
		const bankAccount = this._context.configuration.getBankAccount();
		if (!bankAccount) {
			this.addSubmitError(_("A bank account must be selected"));
		}

		onDone();
	}

	_getStepContent() {
		const bankAccount = this._context.configuration?.getBankAccount();
		return makeDropdown({
			items: this._context.getAccountDropdownItems({
				selectedFn: (account) => bankAccount === account.getNumber(),
			}),
			title: _("Bank account"),
			noDefaultSelection: true,
			noSelectionText: "",
			helpText: _(
				"Select the main bank account where invoices are paid and received.",
			),
			onChange: (selection) => {
				this._context.configuration.setBankAccount(selection?.id);
			},
		});
	}
}
